export function formatExpDate(expDate) {
  try {
    const [year, month, day] = `${expDate}`.match(/\d{2}/g);
    return `${+year + 2000}-${month}-${day}`;
  } catch (error) {
    console.log(error);
  }

  return expDate;
}

export function isExpired(expDate) {
  try {
    const [year, month, day] = `${expDate}`.match(/\d{2}/g);
    const date = new Date(`${+year + 2000}-${month}-${day}T00:00:00`);
    const today = new Date();

    return date.getTime() < today.getTime();
  } catch (error) {
    return false;
  }
}
